import React from 'react';
import styles from '../jefim_tatuador/jefim_tatuador.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HallIcon from '../../icons/hallIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import FacebookIcon from '../../icons/facebookIcon.tsx';

const Jefim_tatuador: React.FC = () => {

    return (
        <div className={styles.jefim_tatuador}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className="mb-3">
                        <a className="pe-1" href="https://wa.me/5517992752562?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                            <WhatsappIcon height="36" color="#ffffff" />
                        </a>
                        <a className="ps-1" href="https://www.instagram.com/jefim_tatuador?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                            <InstagramIcon height="29" color="#ffffff" />
                        </a>
                        <a className="ps-1" href="https://www.facebook.com/jefferson.igor.90" target="_blank">
                            <FacebookIcon height="32" color="#ffffff" />
                        </a>
                    </div>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/UrU3jwZrUpWw4wBJ7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="/jefim_tatuador/sobremim"
                            title="SOBRE MIM"
                            icon={<CatalogIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                        <LinkPersonalizado7
                            href="/jefim_tatuador/tattoo"
                            title="TATTOO"
                            icon={<TattooIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Jefim_tatuador;
